import React from "react";
import LogoMark from "components/logo/images/logo-mark-color.svg";
import Style from "./pulse.module.scss";

export function PulseLoader({ size = 86, percent, showPercent = false, className = "" }) {
  const safePercent = typeof percent === "number" ? Math.max(0, Math.min(100, Math.round(percent))) : null;

  return (
    <span
      className={`${Style.loader} ${className}`.trim()}
      style={{ "--pulse-loader-size": `${size}px` }}
      role="status"
      aria-label="Cargando"
    >
      <span className={Style.visual}>
        <span className={Style.ring} />
        <span className={Style.pulse} />
        <img className={Style.mark} src={LogoMark} alt="" aria-hidden="true" draggable={false} />
      </span>

      {showPercent && safePercent !== null && (
        <span className={Style.percent}>{safePercent}%</span>
      )}
    </span>
  );
}
